import React from 'react';

import BaseLayout from 'shared/ui/BaseLayout/BaseLayout';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';
import {StatusPageView} from 'entities/statusView';

import usePublicStatusPage from '../../model/usePublicStatusPage';

const PublicStatusScreen: React.FC = () => {
    const {data, isLoading, isNotFound, isPdfLoading, onDownloadPdf} = usePublicStatusPage();

    if (isLoading) {
        return <BaseLayout isLoading/>;
    }

    if (isNotFound || !data) {
        return <NotFoundPage/>;
    }

    return (
        <BaseLayout pageTitle={data.name}>
            <StatusPageView data={data} onDownloadPdf={onDownloadPdf} isPdfLoading={isPdfLoading}/>
        </BaseLayout>
    );
};

export default PublicStatusScreen;
